<template>
<div class="nkn-advantage">
  <div class="common-title">{{$t("home.nknAdvantage.title")}}</div>
  <div class="row nkn-advantage-content">
    <div class="col-xs-12 col-sm-12 col-md-4 adv-content">
      <advantage-module>
        <img v-lazy="'/static/img/home/advantage/nodes.png'" class="adv-pic pic-advantage-nodes" slot="advantage-pic">
        <span slot="advantage-title">{{$t("home.nknAdvantage.subtitle1")}}</span>
        <span slot="advantage-content">{{$t("home.nknAdvantage.subContent1")}}</span>
      </advantage-module>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 adv-content">
      <advantage-module>
        <img v-lazy="'/static/img/home/advantage/10G.png'" class="adv-pic pic-advantage-10G" slot="advantage-pic">
        <span slot="advantage-title">{{$t("home.nknAdvantage.subtitle2")}}</span>
        <span slot="advantage-content">{{$t("home.nknAdvantage.subContent2")}}</span>
      </advantage-module>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 adv-content">
      <advantage-module>
        <img v-lazy="'/static/img/home/advantage/server.png'" class="adv-pic pic-advantage-server" slot="advantage-pic">
        <span slot="advantage-title">{{$t("home.nknAdvantage.subtitle4")}}</span>
        <span slot="advantage-content">{{$t("home.nknAdvantage.subContent4")}}</span>
      </advantage-module>
    </div>
  </div>
  <div class="row nkn-advantage-content">
    <div class="col-xs-12 col-sm-12 col-md-4 adv-content">
      <advantage-module>
        <img v-lazy="'/static/img/home/advantage/ID.png'" class="adv-pic pic-advantage-ID" slot="advantage-pic">
        <span slot="advantage-title">{{$t("home.nknAdvantage.subtitle5")}}</span>
        <span slot="advantage-content">{{$t("home.nknAdvantage.subContent5")}}</span>
      </advantage-module>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 adv-content">
      <advantage-module>
        <img v-lazy="'/static/img/home/advantage/security.png'" class="adv-pic pic-advantage-security" slot="advantage-pic">
        <span slot="advantage-title">{{$t("home.nknAdvantage.subtitle6")}}</span>
        <span slot="advantage-content">{{$t("home.nknAdvantage.subContent6")}}</span>
      </advantage-module>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 adv-content">
      <advantage-module>
        <img v-lazy="'/static/img/home/advantage/latency.png'" class="adv-pic pic-advantage-latency" slot="advantage-pic">
        <span slot="advantage-title">{{$t("home.nknAdvantage.subtitle3")}}</span>
        <span slot="advantage-content">{{$t("home.nknAdvantage.subContent3")}}</span>
      </advantage-module>
    </div>
  </div>
</div>
</template>

<script>
import AdvantageModule from '@/components/home/plugins/AdvantageModule'
export default {
  components: {
    AdvantageModule
  }
}
</script>

<style lang="scss" scoped>
.nkn-advantage {
  @include common-inner();

  @media screen and (max-width: 768px) {
    .adv-content {
      margin-bottom: 60px;
    }
  }

  .nkn-advantage-content {
    margin-top: 80px;
    @media screen and (max-width:768px) {
      margin-top: 0;
    }
  }
  .adv-pic {
    width: 120px;
    height: auto;
  }
  .advantage-module {
    @media screen and (max-width: 768px) {

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/home/nknAdvantage.vue